<template>
  <v-dialog v-model="myValue" persistent max-width="960">
    <v-card>
      <v-card-title class="headline">报告</v-card-title>
      <v-card-text>
        <v-row v-if="myData.length > 0" no-gutters>
          <v-col cols="12">
            <v-row class="font-weight-black text-left py-4" no-gutters>
              <v-col cols="3">名称</v-col>
              <v-col cols="3">类型</v-col>
              <v-col cols="3">时间</v-col>
              <v-col cols="3" class="text-right">操作</v-col>
            </v-row>
          </v-col>
          <template v-for="(item, i) in myData">
            <v-col :key="`divider_${i}`" cols="12"><v-divider /></v-col>
            <v-col
              cols="3"
              :key="`project_${i}`"
              class="caption py-4 text-left"
            >
              {{ item.name }}
            </v-col>
            <v-col
              cols="3"
              :key="`project_${i}`"
              class="caption py-4 text-left"
            >
              {{ item.type }}
            </v-col>
            <v-col
              cols="3"
              :key="`project_${i}`"
              class="caption py-4 text-left"
            >
              {{ item.creatTime }}
            </v-col>
            <v-col
              cols="3"
              :key="`project_${i}`"
              class="caption py-4 text-right"
            >
              <v-btn v-if="canAnalysis" small text color="primary" @click="onPreview(item)"
                >预览</v-btn
              >
              <template v-if="item.canDownload">
                <v-btn
                  small
                  text
                  color="primary"
                  @click="onDownload(item)"
                  v-if="myItem.analyseFlag"
                  >下载</v-btn
                >
                <v-btn
                  small
                  text
                  color="primary"
                  @click="onDownloadAll(item)"
                  v-else-if="myItem.pdfFlag"
                  >下载</v-btn
                >
              </template>
            </v-col>
          </template>
        </v-row>
        <v-row v-else style="margin-top: 100px" justify="center" no-gutters>
          <v-col cols="auto" class="text-h3 orange--text">暂无数据</v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="darken-1" @click="myValue = false">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { userFileRead, userFileZip, userFileSpeedKey } from "@/plugins/api";
import Vue from 'vue';

export default {
  components: {},
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    onPreview(item) {
      window.open(item.url, "_blank");
    },
    onDownload(schemaItem) {
      // if (this.myItem.newVersionFlag == '1') {
      //   this.newDownloadTask(schemaItem)
      //   return
      // }
      // fileName:  ${xmh}_${schema}.zip
      let fileName = `${this.myItem.projectNo}_${schemaItem.name}`;
      let schemaZipFile = `/${this.myItem.reportType}/${this.myItem.projectNo}/Result/${schemaItem.name}/${fileName}.zip`;
      // let readParam = { stream: false, path: schemaZipFile };
      this.zipLoading = true;
      this.zipTimer = 0;
      let zipTimerCounter = setInterval(() => this.zipTimer++, 1000);
      // 调用打包接口并显示等待
      let zipParam = {
        path: `/${this.myItem.reportType}/${this.myItem.projectNo}/Result/${schemaItem.name}`,
        fileName: schemaZipFile,
        regex: "[^_].*",
      };
      userFileZip(zipParam, true).then(() => {
        clearInterval(zipTimerCounter);
        zipTimerCounter = undefined;
        this.zipLoading = false;
        // 开始直接下载
        let dto = { path: schemaZipFile };
        // 提示：正在下载中
        this.$message.success('正在下载中，请稍后...');
        //开始下载
        userFileSpeedKey(dto).then((res) => {
          let d = res.data || "";
          let speedDownloadUrl =
            this.Utility.userApi + "/api/pub/file/stream/speed/" + d;
          window.open(speedDownloadUrl);
        });
      });
      // userFileRead(readParam).then((r1) => {
      //   if (r1.data) {
      //     // 直接下载
      //     let dto = { path: schemaZipFile };
      //     userFileSpeedKey(dto).then((res) => {
      //       let d = res.data || "";
      //       let speedDownloadUrl =
      //         this.Utility.userApi + "/api/pub/file/stream/speed/" + d;
      //       window.open(speedDownloadUrl);
      //     });
      //   } else {
      //     this.zipLoading = true;
      //     this.zipTimer = 0;
      //     let zipTimerCounter = setInterval(() => this.zipTimer++, 1000);
      //     // 调用打包接口并显示等待
      //     let zipParam = {
      //       path: `/${this.myItem.reportType}/${this.myItem.projectNo}/Result/${schemaItem.name}`,
      //       fileName: schemaZipFile,
      //       regex: "[^_].*",
      //     };
      //     userFileZip(zipParam).then(() => {
      //       clearInterval(zipTimerCounter);
      //       zipTimerCounter = undefined;
      //       this.zipLoading = false;
      //       // 开始直接下载
      //       let dto = { path: schemaZipFile };
      //       userFileSpeedKey(dto).then((res) => {
      //         let d = res.data || "";
      //         let speedDownloadUrl =
      //           this.Utility.userApi + "/api/pub/file/stream/speed/" + d;
      //         window.open(speedDownloadUrl);
      //       });
      //     });
      //   }
      // });
    },
    newDownloadTask(schemaItem) {
      //新版报告下载任务结果
      let params = {
        projectNo: this.myItem.xmfah,
        filePath: schemaItem.name,
      }
      let myParam = null
      let myForm = document.createElement('form')
      myForm.action = this.Utility.userApi + '/api/report/task/result/download/zip'
      myForm.target = '_self'
      myForm.method = 'post'
      myForm.style.display = 'none'
      myParam = document.createElement('textarea')
      myParam.name = `token`
      myParam.value = Vue.ls.get('token')
      myForm.appendChild(myParam)
      for (let item in params) {
        if (Array.isArray(params[item])) {
          params[item].map((v, index) => {
            myParam = document.createElement('textarea')
            myParam.name = `${item}${index}`
            myParam.value = v
            myForm.appendChild(myParam)
          })
        } else if (typeof params[item] != 'undefined' && params[item] != null) {
          myParam = document.createElement('textarea')
          myParam.name = `${item}`
          myParam.value = params[item]
          myForm.appendChild(myParam)
        }
      }
      document.body.appendChild(myForm)
      myForm.submit()
      myForm.remove()
    },
    onDownloadAll() {
      // pdf报告: /${item.type}/${item.xmh}/报告与附件.zip
      let path = this.myItem.pdfFlag
        ? `/rep/${this.myItem.projectNo}`
        : `/${this.myItem.reportType}/${this.myItem.projectNo}`;
      let fileNameRegx = "^.*.zip";
      let readParam = { stream: false, path: path, regex: fileNameRegx};
      userFileRead(readParam).then((r1) => {
        if (!r1.data) {
          this.$message.error("文件不存在");
          return;
        } else {
          let dto;
          let fileName = "";
          if(r1.message != null) {
            let parts = r1.message.split(',');
            let yasName=`${this.myItem.projectNo}报告与附件.zip`;
            for(let i=0; i<parts.length; i++) {
              if(parts[i] == yasName|| parts[i] == '报告与附件.zip' || parts[i] == '报告及附件.zip'){
                fileName = parts[i];
                break;
              }
            }
            if(fileName == ""){
              this.$message.error("文件压缩包未找到");
              return;
            }

          }
          
          if (this.myItem.pdfFlag)
            dto = { path: `/rep/${this.myItem.projectNo}/${fileName}` };
          else
            dto = {
              path: `/${this.myItem.reportType}/${this.myItem.projectNo}/${fileName}`,
            };
          userFileSpeedKey(dto).then((res) => {
            let d = res.data || "";
            let speedDownloadUrl =
              this.Utility.userApi + "/api/pub/file/stream/speed/" + d;
            window.open(speedDownloadUrl);
          });
        }
      });
    },
  },
  data() {
    return {};
  },
  computed: {
    myValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    myData() {
      return this.data;
    },
    myItem() {
      console.log("123", this.item);
      return this.item;
    },
    canAnalysis() {
      return !(this.item && this.item.rule && this.item.rule.isAnalysis === false)
    },
  },
  created() {},
};
</script>
